import React from 'react';
import './StepTracker.css';

const StepTracker = ({ currentStep, totalSteps = 4 }) => {
  const steps = [
    { number: 1, label: 'Stap 1' },
    { number: 2, label: 'Stap 2' },
    { number: 3, label: 'Stap 3' },
    { number: 4, label: 'Controle' }
  ];

  // Map wizard steps to tracker steps:
  // 1 = 1a, 2 = 1b -> trackerStep = 1
  // 3 = 2
  // 4 = 3a, 5 = 3b -> trackerStep = 3
  // 6 = 4 -> trackerStep = 4
  const getTrackerStep = (step) => {
    if (step === 1 || step === 2) return 1;
    if (step === 3) return 2;
    if (step === 4 || step === 5) return 3;
    if (step === 6) return 4;
    return step;
  };

  const trackerStep = getTrackerStep(currentStep);

  const getStepStatus = (stepNumber) => {
    if (stepNumber <= trackerStep) return 'active';
    return 'inactive';
  };

  const getConnectorStatus = (stepNumber) => {
    return stepNumber < trackerStep ? 'completed' : '';
  };

  return (
    <div className="step-tracker">
      {steps.map((step, index) => (
        <div key={step.number} className="step-item">
          {/* Step Circle */}
          <div className={`step-circle ${getStepStatus(step.number)}`}>
            {step.label}
          </div>
          
          {/* Connector Line (not for last step) */}
          {index < steps.length - 1 && (
            <div className={`step-connector ${getConnectorStatus(step.number)}`}></div>
          )}
        </div>
      ))}
    </div>
  );
};

export default StepTracker;